module.exports = __webpack_public_path__ + "static/media/cw-image.2dec7046.png";